export const MAX_CUSTOM_FIELD_COUNT = 5

export const MAX_FINANCIAL_METRIC_COUNT = 1

export const ATTRIBUTION_IDS = {
  HYBRID: '1',
  CLICK_BASED: '2',
  VIEW_BASED: '3',
}

export const ADVANCED_SETTING_NAME = {
  POST_CLICK: 'post_click_interval',
  POST_VIEW: 'post_view_interval',
  CROSS_MODELING: 'cross_device',
}

export const DEFAULT_VALUES = {
  POST_CLICK: 15,
  POST_VIEW: 28,
  CONVERSION_COUNT: 0,
  CONVERSION_FREQUENCY: 0,
  CONVERSION_UNIT: 'Day',
}

export const MAX_NAME_CHARS = 255

export const MAX_CUSTOM_FIELD_CHARS = 255

export const EMPTY_SPACE_REGEX = /\s/g

export const ALPHANUMERIC_UNDERSCORE_REGEX = /^[a-zA-Z0-9_ ]+$/

export const EMAIL_REGEX =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((([a-zA-Z0-9]+)(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,})$/

export const URL_REGEX =
  /^(?:(?:https?):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i

export const MAX_REPEATED_SETTING_VALUES: { [key: string]: number } = {
  Hour: 23,
  Day: 6,
}

export const MAX_PIXEL_CUSTOMIZATION_CHARS = 40
